export default __webpack_public_path__ + "static/media/ninos-Personaje-02-1.59162ff0.png";